import { create } from "zustand";
import { persist } from "zustand/middleware";

export type ProgressCardRunFlow = "cv-review" | "cv-tailoring" | "cover-letter";

type ProgressCardRunKeyParams = {
  flow: ProgressCardRunFlow;
  accountUploadId?: number | null;
  jobId?: number | null;
};

interface ProgressCardRunStore {
  completedProgressKeys: Record<string, true>;
  hasCompletedProgress(_params: ProgressCardRunKeyParams): boolean;
  markProgressCompleted(_params: ProgressCardRunKeyParams): void;
}

function getProgressCardRunKey({
  flow,
  accountUploadId,
  jobId,
}: ProgressCardRunKeyParams) {
  if (!accountUploadId || !jobId) return undefined;

  return `${flow}:${accountUploadId}:${jobId}`;
}

export const useProgressCardRunStore = create<ProgressCardRunStore>()(
  persist(
    (set, get) => ({
      completedProgressKeys: {},
      hasCompletedProgress: (params) => {
        const key = getProgressCardRunKey(params);

        return Boolean(key && get().completedProgressKeys[key]);
      },
      markProgressCompleted: (params) => {
        const key = getProgressCardRunKey(params);

        if (!key) return;

        set((state) => ({
          completedProgressKeys: {
            ...state.completedProgressKeys,
            [key]: true,
          },
        }));
      },
    }),
    {
      name: "progress-card-run-store",
    }
  )
);
